import {lazy} from 'react'

export const ElaAssignArticleComponentContainer = lazy(
  () => import('./../../../../../ela/articles/components/assign-article')
)

export const ElaAssignAssessmentHandler = lazy(
  () => import('./../../../../../ela/assessment/components/assign-assessment')
)

export const ElaAssignWordStudyHandler = lazy(
  () => import('./../../../../../ela/word-study/components/assign-word-study/')
)

export const ElaAssignSkillPracticeHandler = lazy(
  () => import('./../../../../../ela/adaptive-skills/components/assign-skill-practice/')
)

export const ElaAssignmentsHandler = lazy(
  () => import('./../../../../../ela/common/components/assignments/')
)

export const AssignDecodablePage = lazy(
  () => import('./../../../../../ela/decodables/components/assign-decodable')
)

export const ElaArticleDescriptionHandler = lazy(
  () => import('./../../../../../ela/articles/components/article-page')
)

export const ArticlesComponentContainer = lazy(
  () => import('./../../../../../ela/articles/components/articles-page')
)

export const ElaFocusSkillsPracticeAssignmentsHandler = lazy(
  () => import('./../../../../../pages/assign-focus-skills-practice/ela')
)
